import { motion } from 'framer-motion';
import './AnimatedTabs.css';

export interface Tab<T extends string = string> {
    id: T;
    label: string;
    badge?: number;
}

interface AnimatedTabsProps<T extends string> {
    tabs: Tab<T>[];
    activeTab: T;
    onTabChange: (tabId: T) => void;
    layoutId?: string;
}

export function AnimatedTabs<T extends string>({
    tabs,
    activeTab,
    onTabChange,
    layoutId = 'animated-tab-underline'
}: AnimatedTabsProps<T>) {
    return (
        <nav className="animated-tabs">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    className={`animated-tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    {tab.label}
                    {tab.badge !== undefined && tab.badge > 0 && (
                        <span className="animated-tab-badge">{tab.badge}</span>
                    )}
                    {activeTab === tab.id && (
                        <motion.div
                            className="animated-tab-underline"
                            layoutId={layoutId}
                            transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                        />
                    )}
                </button>
            ))}
        </nav>
    );
}

export default AnimatedTabs;
